import swal from "sweetalert"
import shop from "shop/shop"

const requestPassword = ({email} = {}) => {

  swal( {
      text:             translate( "Bitte geben Sie Ihr altes Passwort ein" ),
      type:             "prompt",
      title:            translate( "Altes Passwort" ),
      showCancelButton: true,
      closeOnConfirm:   false,
      closeOnCancel:    true,
    },
    oldPassword => {
      if ( !oldPassword ) return
      swal( {
          text:             translate( "Bitte geben Sie Ihr neues Passwort ein" ),
          type:             "input",
          title:            translate( "Neues Passwort" ),
          showCancelButton: true,
          closeOnConfirm:   false,
          closeOnCancel:    true,
        },
        newPassword => {
          if ( !oldPassword || !newPassword ) return
          shop.setPassword( { oldPassword, newPassword } )
            .then( res => {
              swal( translate( "reset.success" ),
                translate( "Passwort erfolgreich gesetzt." ),
                "success" )
            } )
            .catch( err => {
              console.error(err)
              swal( "Fehler", translate( "Leider konnte Ihr Passwort nicht geändert werden." ), "error" )
            } )
        } )

    }
  )
}

export default requestPassword



// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Account/requestPassword.js